/**
 * The packing rule behind the pager (PF4), kept apart from React so it can be
 * tested on its own: see `paging.tsx` for why a page is sized to the window.
 */

export type PageRange = readonly [start: number, end: number];

/**
 * Split items into pages of whole items, in order, each fitting `budget`.
 * An item taller than the budget gets a page of its own rather than none.
 */
export function packPages(heights: readonly number[], budget: number, gap: number): PageRange[] {
  if (heights.length === 0) return [[0, 0]];
  const pages: PageRange[] = [];
  let start = 0;
  let used = 0;

  heights.forEach((height, index) => {
    const added = index > start ? gap + height : height;
    if (index > start && used + added > budget) {
      pages.push([start, index]);
      start = index;
      used = height;
    } else {
      used += added;
    }
  });
  pages.push([start, heights.length]);
  return pages;
}
